<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="share" v-bind="attrs" v-on="on" depressed text>
        <v-icon class="mr-2"> fa fa-share-alt </v-icon>
        Compartilhar
      </v-btn>
    </template>
    <v-list>
      <v-list-item class="px-0">
        <v-btn
          @click="newWindow('facebook')"
          color="primary"
          width="100%"
          text
          class="justify-start share-item"
        >
          <v-icon class="facebook-icon mr-2"> fab fa-facebook </v-icon>
          FACEBOOK
        </v-btn>
      </v-list-item>

      <v-list-item class="px-0">
        <v-btn
          @click="newWindow('whatsapp')"
          color="primary"
          width="100%"
          text
          class="justify-start share-item"
        >
          <v-icon class="whatsapp-icon mr-2"> fab fa-whatsapp </v-icon>
          WHATSAPP
        </v-btn>
      </v-list-item>

      <v-list-item class="px-0">
        <v-btn
          @click="newWindow('twitter')"
          color="primary"
          width="100%"
          text
          class="justify-start share-item"
        >
          <v-icon class="twitter-icon mr-2"> fab fa-twitter </v-icon>
          TWITTER
        </v-btn>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ShareButtons",
  methods: {
    newWindow(type) {
      let url = "";
      switch (type) {
        case "facebook":
          url = `https://www.facebook.com/sharer.php?u=${
            this.server + this.$route.fullPath
          }`;
          break;
        case "twitter":
          url = `https://twitter.com/share?url=${
            this.server + this.$route.fullPath
          }`;
          break;
        case "whatsapp":
          url = `https://wa.me/?text=${this.server + this.$route.fullPath}`;
          break;
      }
      window.open(
        url,
        "Compartilhar",
        "width=600,height=300,left=" +
          (screen.availWidth / 2 - 300) +
          ",top=" +
          (screen.availHeight / 2 - 150) +
          ""
      );
    },
  },
};
</script>

<style scoped>
.share {
  background-color: #3b5998;
  color: #ffffff;
  font-size: 14px;
}

.share .v-icon {
  font-size: 16px;
}

.share-item {
  letter-spacing: 0.2px;
}

.facebook-icon {
  color: #4267b2 !important;
}

.whatsapp-icon {
  color: #25d366 !important;
}

.twitter-icon {
  color: #1da1f2 !important;
}
</style>
